import classNames from 'classnames';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { categoriesProvider } from './categories';
import { Message } from '../commons/message/message';
import { useDispatch, useSelector } from 'react-redux';
import { setLocation } from '../../store';
import './index.scss';
import { NavigationSwitch } from './navigationSwitch';
import { gaSectionAccess } from '../../services/analitics';

export const NavigationMenu = ({ initialState }) => {
  const navTabsRef = useRef();
  const { floorStatics, storeId, userLocale } = useSelector(
    (state) => state.config
  );
  const { locationKey } = useSelector((state) => state.location);
  const categories = useCallback(categoriesProvider(floorStatics), []);

  const [activeSection, setActiveSection] = useState(
    initialState || categories[0].key
  );
  const dispatch = useDispatch();

  const onSwitchTab = useCallback(
    (key) => {
      setActiveSection(key);
      const tab = categories.find((category) => category.key === key);

      dispatch(
        setLocation(
          tab.key,
          tab.floor,
          tab.section,
          tab.floorKey,
          tab.sectionKey
        )
      );
      if (
        tab.key !== locationKey ||
        sessionStorage.getItem('gaSectionFromPreHome')
      ) {
        sessionStorage.removeItem('gaSectionFromPreHome');
        gaSectionAccess(storeId, userLocale, tab.floorKey, tab.sectionKey);
      }
    },
    [categories, dispatch, locationKey, storeId, userLocale]
  );

  useEffect(() => {
    onSwitchTab(activeSection);
  }, [activeSection, onSwitchTab]);

  return (
    <div className={'navigation-menu'}>
      <div className="navigation-categories">
        <ul ref={navTabsRef} className={'navigation-categories__container'}>
          {categories.map((category) => (
            <li
              key={category.key}
              onClick={() => setActiveSection(category.key)}
              className={classNames({
                active: category.key === activeSection,
              })}
            >
              <Message
                className={classNames({
                  'zds-heading-s-highlight': category.key === activeSection,
                  'zds-heading-s': category.key !== activeSection,
                })}
                id={category.section}
                tag="p"
              />
              <Message className={'zds-body-xs '} id={category.floor} tag="p" />
            </li>
          ))}
        </ul>
      </div>
      {/* <MenuGroup
        activeTab={activeSection}
        setActiveSection={setActiveSection}
        sizeRef={navTabsRef.current?.clientWidth}
      /> */}
      <div className="zara-menu__spacer">
        <NavigationSwitch activeCategory={activeSection} />
      </div>
    </div>
  );
};
